import React, { useState, useEffect } from 'react';
import styles from './CaseArchiveBanner.module.scss';
import caseIcon from '../../../assets/Icons/caseIcon.svg?url';
import starIcon from '../../../assets/Icons/starwithborder.svg?url';
import { Loader } from '@/components/Loader/Loader';

interface CaseArchiveBannerProps {
  caseData: any;
}

const CaseArchiveBanner: React.FC<CaseArchiveBannerProps> = ({ caseData }) => {
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    if (caseData?.details?.image_url) {
      setImageLoading(true);
      const img = new Image();
      img.onload = () => {
        setBackgroundImageUrl(caseData.details.image_url);
        setImageLoading(false);
      };
      img.onerror = () => {
        setImageLoading(false);
      };
      img.src = caseData.details.image_url;
    } else {
      setImageLoading(false);
    }
  }, [caseData]);

  if (imageLoading) {
    return (
      <div className={styles.banner}>
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.banner}
      style={{
        backgroundImage: backgroundImageUrl
          ? `url(${backgroundImageUrl})`
          : 'url(../../../public/casebg.webp)',
      }}
    >
      <div className={styles.bannerInfoBottom}>
        <div>
          <img src={caseIcon} alt="" />
          <div>Вместимость сейфа:</div>
        </div>
        <div>
          <img src={starIcon} alt="" />
          <div>{caseData?.main_prize?.amount?.toLocaleString() || '0'}</div>
        </div>
      </div>
    </div>
  );
};

export default CaseArchiveBanner;
